import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./Tax/Main";
import Form from "./Tax/Form";

// Utils
import { getData, getAlert, getDataWithComp } from "../../../utils/SamuiUtils";

import { getReport } from "../../../utils/ReportUtils";

const Tax = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [maxBiNo, setMaxBiNo] = useState();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp(
        "API_1702_WTAX_D",
        `ORDER BY WTAX_Id desc`
      );
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
        // const maxBi = getMaxWTFormId(masterList, "HT", "WT_Form_Id");
        // setMaxBiNo(maxBi);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onPageUpdate = (docNo) => {
    setMaxBiNo(docNo);
    setMode("U");
  };

  // const getCurrentYearMonth2 = () => {
  //   const now = new Date();
  //   const year = now.getFullYear() + 543;
  //   const currentYear = year.toString().slice(-2);
  //   return { currentYear };
  // };
  // const getMaxWTFormId = (list, title, field) => {
  //   const { currentYear } = getCurrentYearMonth2();

  //   if (!list || list.length < 1) {
  //     return `${title}${currentYear}/00001`;
  //   }

  //   const ids = list.map((item) => item[field]);

  //   const latestDoc = ids.reduce((latest, doc) => {
  //     const yearFromDoc = doc?.slice(title.length, title.length + 2);
  //     if (!latest || doc > latest) {
  //       return doc;
  //     }
  //     return latest;
  //   }, null);

  //   const yearFromDoc = latestDoc?.slice(title.length, title.length + 2);

  //   if (yearFromDoc !== currentYear) {
  //     return `${title}${currentYear}/00001`;
  //   }

  //   return incrementWT_Form_Id(latestDoc, title);
  // };

  // const incrementWT_Form_Id = (docNo, title) => {
  //   const prefixLength = title.length + 4;
  //   const prefix = docNo.slice(0, prefixLength);
  //   const numPart = parseInt(docNo.slice(prefixLength + 1));
  //   const incrementedNum = (numPart + 1).toString().padStart(5, "0");
  //   return `${prefix}/${incrementedNum}`;
  // };

  return (
    <div>
      <div className="Invoice">
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className="btn btn-toggle-sidebar"
          style={{
            position: "fixed",
            top: "1rem",
            left: isSidebarOpen ? "190px" : "-15px",
            zIndex: 1001,
            background: "transparent",
            border: "none",
            color: "#EF6C00",
            fontSize: "20px",
          }}
        >
          {isSidebarOpen ? "✖" : "☰"}
        </button>
        <div className="wrapper">
          <Sidebar
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
          />
          <div
            className={`main-panel ${
              isSidebarOpen ? "sidebar-open" : "sidebar-closed"
            }`}
          >
            <div className="container">
              <div className="page-inner">
                {mode === "S" ? (
                  <Main
                    name={"หนังสือหัก ณ ที่จ่าย"}
                    dataMasterList={dataMasterList}
                    onPageInsert={() => onPageInsert()}
                    onPageUpdate={(docNo) => onPageUpdate(docNo)}
                  />
                ) : (
                  <Form
                    callInitialize={initialize}
                    mode={mode}
                    name={"หนังสือหัก ณ ที่จ่าย"}
                    docNo={maxBiNo}
                    getReport={getReport}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tax;
